//import styles from './PaymentFailedDialog.module.scss'
import { useHistory } from 'react-router'

import ConfirmationDialog from '../ConfirmationDialog/index'
import { ReactComponent as FailedIcon } from './failed.svg'

const PaymentFailedDialog = ({ setShowPaymentFailedDialog, message, rootPath }) => {
  const history = useHistory()
  const hotelSetupRoute = '/hotel-setup'

  const handleConfirm = () => {
    if (rootPath === 'billing') {
      setShowPaymentFailedDialog({ status: false, message: '' })
    } else {
      setShowPaymentFailedDialog({ status: false, message: '' })
      history.push(hotelSetupRoute)
    }
  }

  const handleClose = () => {
    setShowPaymentFailedDialog({ status: false, message: '' })
  }

  return (
    <ConfirmationDialog
      positiveMessage="Try another method"
      onConfirm={handleConfirm}
      onClose={handleClose}
      title="We couldn’t charge this method"
      titleIcon={<FailedIcon />}
    >
      <p>{message}</p>
    </ConfirmationDialog>
  )
}

export default PaymentFailedDialog
